import { FeatureFlag } from '@ps/web-core-store';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import type { Selector } from 'reselect';

import useFeature from '@swf/core/hooks/useFeature';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { getLocaleCode } from '@swf/core/utils';
import localeData from '@swf/generated/locale-data.json';

import type { Props } from '../LocalesDropDown';
import styles from '../LocalesDropDown.scss';

const LocalesMenu: React.FC<Props> = ({ className }) => {
  const locales = useSelector(select.cms.getWebsiteLanguages);
  const pathname = useSelector(select.location.stripPrefix as Selector<RootState, string>);
  const forceDefaultLocale = useFeature(FeatureFlag.ForceDefaultLocale);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {locales.map((item, index) => {
        const code = getLocaleCode(item);
        const href = (index === 0 && !forceDefaultLocale ? pathname : `/${code}${pathname}`) || '/';
        return code ? (
          <li className={classNames(className, styles.menuItem)} key={code}>
            <a href={href} rel="nofollow">
              {localeData[code].name}
            </a>
          </li>
        ) : null;
      })}
    </>
  );
};

export default LocalesMenu;
